import { render } from "./BalansirEditor.vue?vue&type=template&id=67e4855c&scoped=true"
import script from "./BalansirEditor.vue?vue&type=script&lang=js"
export * from "./BalansirEditor.vue?vue&type=script&lang=js"

import "./BalansirEditor.vue?vue&type=style&index=0&id=67e4855c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e4855c"]])

export default __exports__